module.exports = __webpack_public_path__ + "Mars_discovery_map.png?6456055a05937f14efecd50fc55ec3eb";